<!-- <div *ngIf="mapData?.mapUrl?.length; else noMapData"> -->
<div id="mapContainer" class="ml-100; pt-20;" style="text-align: center;">
    <!-- Layout Version Selection Modal -->
    <p-dialog [(visible)]="showLayoutVersionModal" [modal]="true" [dismissableMask]="true" [closable]="true"
        [resizable]="false" [style]="{width:'22rem'}" (onHide)="closeLayoutVersionModal()"
        contentStyle="padding: 1.5em 1.2em;" [styleClass]="'layout-version-modal-dark'">
        <ng-template pTemplate="header">
            <span class="text-lg font-bold">Select Layout Version</span>
        </ng-template>
        <ng-template pTemplate="content">
            <div *ngFor="let version of mapData.layoutVersions" class="layout-version-card"
                [ngClass]="{'selected': selectedLayoutVersion === version}"
                (click)="selectedLayoutVersion = version; onLayoutVersionChange($event); closeLayoutVersionModal()">
                <span>{{ version.versionName || version.name || version }}</span>
            </div>
        </ng-template>
    </p-dialog>
    <!-- This input is not supposed to delete as it will be used for testing purpose -->
    <!-- <input type="file" (change)="onFileSelected($event)" /> -->
    <span *ngIf="mapData?.kmlFor?.toLowerCase()=='acquisition' && mapData?.mapLevel!= 'khasra'">
        <div class="toggle-container">
            <div class="toggle-item d-flex align-items-center gap-2">
                <span class="input-switch">{{ DMPLabelName}}</span>
                <p-inputSwitch [(ngModel)]="showDistrictMasterPlan" name="showDistrictMasterPlan"
                    (onChange)="toggleZone('DMP', $event)"></p-inputSwitch>
            </div>
            <div class="toggle-item d-flex align-items-center gap-2">
                <span class="input-switch">Village Master Plan</span>
                <p-inputSwitch [(ngModel)]="showVillageMasterPlan" name="showVillageMasterPlan"
                    (onChange)="toggleZone('VMP', $event)"></p-inputSwitch>
            </div>
            <!-- <div class="toggle-item d-flex align-items-center gap-2" *ngIf="isDCUP">
                <span class="input-switch">DIC Master Plan</span>
                <p-inputSwitch [(ngModel)]="showDicMasterPlan" name="showDicMasterPlan"
                    (onChange)="toggleZone('DIC', $event)"></p-inputSwitch>
            </div> -->
            <div class="toggle-item d-flex align-items-center gap-2">
                <span class="input-switch">Roads</span>
                <p-inputSwitch [(ngModel)]="showRoads" name="showRoads"
                    (onChange)="toggleZone('Roads', $event)"></p-inputSwitch>
            </div>
            <div class="toggle-item d-flex align-items-center gap-2"
                *ngIf="mapData?.districtName?.toLowerCase() =='ayodhya' || mapData?.districtName?.toLowerCase() =='gonda'">
                <span class="input-switch">COD</span>
                <p-inputSwitch [(ngModel)]="showCOD" name="showCOD"
                    (onChange)="toggleZone('COD', $event)"></p-inputSwitch>
            </div>
            <div class="toggle-item d-flex align-items-center gap-2">
                <span class="input-switch">Labels</span>
                <p-inputSwitch [(ngModel)]="showLabels" name="showLabels"
                    (onChange)="toggleNormalMarker($event)"></p-inputSwitch>
            </div>
        </div>
    </span>

    <!-- Toggles for Layouts/Inventory -->
    <span *ngIf="mapData?.kmlFor?.toLowerCase()=='inventory'">
        <div class="kml-toggle-section"
            style="display: flex; justify-content: center; align-items: center; gap: 12px; flex-wrap: wrap; padding: 12px 0;">
            <!-- Barren Toggle Icon -->
            <i *ngIf="mapData?.kmlLevel?.toLowerCase() !== 'operations'" class="fas fa-earth-americas kml-toggle-icon" [class.active]="showBarren"
                (click)="showBarren = !showBarren; toggleZone('Barren', { checked: showBarren })" pTooltip="Barren"
                tooltipPosition="top" tooltipStyleClass="yellow-tooltip"></i>

            <!-- Village Master Plan (Zonal Info) Toggle Icon -->
            <i *ngIf="mapData?.kmlLevel?.toLowerCase() !== 'operations'" class="fas fa-circle-nodes kml-toggle-icon" [class.active]="showVillageMasterPlan"
                (click)="showVillageMasterPlan = !showVillageMasterPlan; toggleZone('VMP', { checked: showVillageMasterPlan })"
                pTooltip="Zoning" tooltipPosition="top" tooltipStyleClass="yellow-tooltip"></i>

            <!-- Stitched Toggle Icon -->
            <i *ngIf="mapData?.kmlLevel?.toLowerCase() !== 'operations'" class="fas fa-puzzle-piece kml-toggle-icon" [class.active]="showStitched"
                (click)="showStitched = !showStitched; toggleZone('Stitched', { checked: showStitched })"
                pTooltip="Stitched" tooltipPosition="top" tooltipStyleClass="yellow-tooltip"></i>

            <!-- Layout Toggle Icon -->
            <i *ngIf="mapData?.kmlLevel?.toLowerCase() !== 'operations'" class="fas fa-border-all kml-toggle-icon" [class.active]="showLayout"
                (click)="showLayout = !showLayout; toggleZone('Layout', { checked: showLayout })" pTooltip="Layout"
                tooltipPosition="top" tooltipStyleClass="yellow-tooltip"></i>

            <!-- Artist/Visualise Toggle Icon -->
            <i *ngIf="mapData?.kmlLevel?.toLowerCase() !== 'operations'" class="fas fa-paintbrush kml-toggle-icon" [class.active]="showVisualise"
                (click)="showVisualise = !showVisualise; toggleZone('Visualise', { checked: showVisualise })"
                pTooltip="Artist" tooltipPosition="top" tooltipStyleClass="yellow-tooltip"></i>

            <!-- Labels Toggle Icon -->
            <i class="fas fa-tags kml-toggle-icon" [class.active]="showLabels"
                (click)="showLabels = !showLabels; toggleNormalMarker({ checked: showLabels })" pTooltip="Labels"
                tooltipPosition="top" tooltipStyleClass="yellow-tooltip"></i>

            <!-- Layout Version Icon (Section Icon - Always Theme Green) -->
            <i *ngIf="mapData?.layoutVersions?.length > 1"
                class="fas fa-layer-group kml-toggle-icon layout-version-icon" (click)="openLayoutVersionModal()"
                pTooltip="Layout Version" tooltipPosition="top" tooltipStyleClass="yellow-tooltip"></i>

            <!-- KML Upload Icon (Always Greenish - Not a Toggle) - Only visible if user has Upload_Kml role and level is not operations -->
            <i *ngIf="canUploadKml && mapData?.kmlLevel?.toLowerCase() !== 'operations'" class="fas fa-cloud-upload-alt kml-toggle-icon kml-upload-icon"
                (click)="openKmlUploadDialog()" pTooltip="Upload KML" tooltipPosition="top"
                tooltipStyleClass="yellow-tooltip"></i>
        </div>
    </span>

    <!-- KML Upload Component -->
    <app-kml-upload [(visible)]="showKmlUploadModal" [mapData]="mapData"
        (layoutVersionChanged)="onKmlVersionChangeSubmitted($event)"></app-kml-upload>

    <div id="map" #map style="width:95%;height:600px; border: solid; border-color: lightgray; border-radius: 1em;">
    </div>
</div>
<!-- </div> -->
<ng-template #noMapData>
    Map details not found
</ng-template>

<!-- <div class="farmer-list">-->
<p-dialog [(visible)]="showOwnerModal" [modal]="true" [dismissableMask]="true" [closable]="true" [resizable]="false"
    [style]="{width:'30rem'}">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold">Owners Details</span>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="document-block mt-2">
            <div class="formSection">
                <div class="head">
                    <strong>Owners ({{currentKhasraData?.farmers ? currentKhasraData?.farmers?.length : '0'}})</strong>
                    <span style="float: right;">
                        <img src="../../assets/images/DashboardIcon.svg"
                            style="height:30px; width: 30px; padding-top: 10px;" />
                    </span>
                </div>
                <table>
                    <th class="col-md-4">Farmer Name</th>
                    <tr class="flex flex-col gap-2" *ngFor="let farmer of currentKhasraData?.farmers; ">
                        <td>
                            <span (click)="openFarmerModal(farmer)"
                                style="cursor:pointer; text-decoration: none; color: blue;">
                                {{((farmer?.firstName)?(farmer?.firstName):'') + " " +
                                ((farmer?.lastName)?(farmer?.lastName):'')}}
                            </span><span *ngIf="farmer?.aadharNo">({{farmer?.aadharNo}})</span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </ng-template>
</p-dialog>

<!-- Calendar Month View Modal -->
<!-- Always visible calendar month view panel -->
<p-dialog [(visible)]="showCalendarModal" [modal]="true" [dismissableMask]="false" [closable]="true" [resizable]="false"
    [style]="{width:'330px', minWidth: '330px', maxWidth: '340px'}">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold" *ngIf="enabledDates.length >0">Select Date</span>
        <span class="text-lg font-bold" *ngIf="enabledDates.length <=0">No Media File</span>
    </ng-template>
    <ng-template pTemplate="content">
        <div style="display: flex; flex-direction: column; align-items: center;"
            *ngIf="enabledDates.length >0; else elseBlock">
            <p-calendar dateFormat="dd/mm/yy" (onSelect)="getMediaFilesForDate($event)" [minDate]="minDate"
                [maxDate]="maxDate" [inline]="true" [view]="'date'">
                <ng-template pTemplate="date" let-date>
                    <span [ngClass]="{'highlight-date': isHighlighted(date)}">
                        {{ date.day }}
                    </span>
                </ng-template>
            </p-calendar>
        </div>
    </ng-template>
    <ng-template #elseBlock>
        <div style="display: flex; flex-direction: column; align-items: center;">
            No media file found.
        </div>
    </ng-template>
</p-dialog>

<!-- Modal to display gallery of khasra -->
<p-dialog [(visible)]="showMediaModal" [modal]="true" [dismissableMask]="false"
    [style]="{width:'50rem', height: '30rem'}">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold">Gallery : {{ currentTimelineDate }}</span>
    </ng-template>
    <ng-template pTemplate="content">
        <!-- Pics -->
        <div class="p-4">
            <div class="formSection" *ngIf="currentKhasraPics && currentKhasraPics.length > 0">
                <div class="head">
                    <strong>Pics</strong>
                </div>
            </div>
            <div id="khasra-pics"
                style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 12px; scroll-behavior: auto;">
                <span *ngFor="let image of currentKhasraPics; let i = index">
                    <img src="{{currentKhasraPics[i]}}" class="d-block"
                        style="width: 150px; height: auto; margin: 8px 0; cursor: pointer;" alt="Image"
                        (click)="openImageInFullScreen(currentKhasraPics[i])" />
                </span>
            </div>
        </div>
        <!-- Videos -->
        <div class="p-4">
            <div class="formSection" *ngIf="currentKhasraVideos && currentKhasraVideos.length > 0">
                <div class="head">
                    <strong>Videos</strong>
                </div>
            </div>
            <div id="khasra-videos"
                style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 12px; scroll-behavior: auto;">
                <span *ngFor="let image of currentKhasraVideos; let i = index">
                    <video [src]="currentKhasraVideos[i]" class="d-block"
                        style="width: 150px; height: auto; margin: 8px 0; cursor: pointer;" controls muted
                        preload="metadata">
                        Your browser does not support the video tag.
                    </video>
                </span>
            </div>
        </div>
        <div
            *ngIf="(!currentKhasraVideos || currentKhasraVideos.length === 0) && (!currentKhasraPics || currentKhasraPics.length === 0)">
            No Pic/Video found.
        </div>
    </ng-template>
</p-dialog>

<!-- Modal to open pics in full view -->
<p-dialog [(visible)]="showPicModal" *ngIf="currentSelectedPic || currentSelectedVideo" [modal]="true"
    [dismissableMask]="true" [style]="{width:'60rem'}">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold">Gallery : {{ currentTimelineDate }}</span>
    </ng-template>
    <ng-template pTemplate="content">
        <img src="{{currentSelectedPic}}" *ngIf="currentSelectedPic" class="cursor-pointer"
            style="width: 100%; height: 100%;" />
    </ng-template>
</p-dialog>

<!-- Document Modal to to show all documents khasra on which user will click -->
<p-dialog [(visible)]="showDocumentModal" [modal]="true" [dismissableMask]="true" [closable]="true" [resizable]="false"
    [style]="{width:'40rem'}">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold">Document List of Khasra #{{currPolygondata?.name}}</span>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="document-block mt-2">
            <app-documents [docEntityData]="currPolygondata" [showIsVerified]="true"></app-documents>
        </div>
    </ng-template>
</p-dialog>

<!-- Owner/Farmer Details Modal to to show owner/Farmer on which user clicks -->
<p-dialog [(visible)]="showOwnerDetailsModal" [modal]="true" [dismissableMask]="true" [closable]="true"
    [resizable]="false" [style]="{width:'50rem'}">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold">Owner Details #{{currentOwnerData?.id}}</span>
    </ng-template>
    <ng-template pTemplate="content">
        <app-farmer-details [farmer]="currentOwnerData" (khasraClicked)="openKhasraModal($event)"></app-farmer-details>
    </ng-template>
</p-dialog>



<!-- Khasra Details Modal to to show khasra details on which user clicks -->
<p-dialog [(visible)]="showkhasraDetailsModal" [modal]="true" [dismissableMask]="true" [closable]="true"
    [resizable]="false" [style]="{width:'50rem'}">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold">Khasra Details #{{currentClickedKhasraOnFarmerModalData?.id}}</span>
    </ng-template>
    <ng-template pTemplate="content">
        <app-khasra-details [khasra]="currentClickedKhasraOnFarmerModalData" (khasraClicked)="openKhasraModal($event)"
            (farmerClicked)="openFarmerModal($event)"></app-khasra-details>
    </ng-template>
</p-dialog>


<!-- Client Details Modal to to show Client's details for unit on which user clicks -->
<p-dialog [(visible)]="showClientDetailsModal" [modal]="true" [dismissableMask]="true" [closable]="true"
    [resizable]="false" [style]="{width:'50rem'}">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold">Client Details #{{currentOwnerData?.id}}</span>
    </ng-template>
    <ng-template pTemplate="content">
        <app-client-details [client]="currentOwnerData" [currentUnitSaleDetails]="currentUnitSaleRecord">
        </app-client-details>
    </ng-template>
</p-dialog>


<!-- KYC and Property Document Modal to to show Client's details Documents for unit on which user clicks and KYC Documents -->
<p-dialog [(visible)]="showKYCPanel" [modal]="true" [dismissableMask]="true" [closable]="true" [resizable]="false"
    [style]="{width:'70rem'}">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold">Documents -Unit No. {{currPolygondata?.name}}</span>
    </ng-template>
    <ng-template pTemplate="content">
        <app-kyc-pannel [kycPannel]="" [userData]="currentOwnerData"></app-kyc-pannel>
    </ng-template>
</p-dialog>